import React from 'react';
import { AgFinancingCreditAnalysisStatus, Credit } from '@indigo-ag/schema';
import { Tag, TagProps } from '@indigo-ag/component-module';

import i18next from 'core/i18n';
import { text } from 'shared';

const creditStatusLabelMap: Record<Credit['status'], string> = {
  [AgFinancingCreditAnalysisStatus.STARTED]: i18next.t('in_process'),
  [AgFinancingCreditAnalysisStatus.COMPLETED]: i18next.t('completed'),
  [AgFinancingCreditAnalysisStatus.ON_HOLD]: i18next.t('onHold'),
  // * deprecated
  [AgFinancingCreditAnalysisStatus.APPROVED]: i18next.t('approved'),
  [AgFinancingCreditAnalysisStatus.DENIED]: i18next.t('denied'),
  [AgFinancingCreditAnalysisStatus.WAITING_CREDIT_MANAGER_DECISION]: i18next.t('sentToCommittee')
};

const creditStatusVariantMap: Record<Credit['status'], TagProps['variant']> = {
  [AgFinancingCreditAnalysisStatus.STARTED]: 'info',
  [AgFinancingCreditAnalysisStatus.COMPLETED]: 'success',
  [AgFinancingCreditAnalysisStatus.ON_HOLD]: 'warning',
  // * deprecated
  [AgFinancingCreditAnalysisStatus.APPROVED]: 'success',
  [AgFinancingCreditAnalysisStatus.DENIED]: 'error',
  [AgFinancingCreditAnalysisStatus.WAITING_CREDIT_MANAGER_DECISION]: 'warning'
};

interface CreditAnalysisStatusTagProps {
  status: Credit['status'];
}

export const CreditAnalysisStatusTag: React.FunctionComponent<CreditAnalysisStatusTagProps> = ({ status }) => {
  return <Tag label={text.toTitleCase(creditStatusLabelMap[status])} variant={creditStatusVariantMap[status]} />;
};
